/**
 * Brand assets registry. Keep paths and alt text centralized so the exact,
 * unmodified uploaded files are used everywhere.
 *
 * Files in /public/brand/ are served by CRA at "/brand/...".
 */
export const BRAND = {
  primaryLogo: "/brand/pathways-to-purpose-primary-transparent.png",
  appIcon: "/brand/pathways-to-purpose-app-icon.png",
  alt: "Pathways to Purpose — an Our Square program. Love Heals.",
  colors: {
    navy: "#0B2D59",
    royal: "#0A5FB3",
    teal: "#00A7B5",
    white: "#FFFFFF",
  },
};

/**
 * Full primary logo lockup. Used for welcome page, login page,
 * confirmation page and desktop header.
 * Pass `maxWidth` (in pixels) to constrain size while preserving proportions.
 */
export function PrimaryLogo({ maxWidth = 220, className = "", style = {} }) {
  return (
    <img
      src={BRAND.primaryLogo}
      alt={BRAND.alt}
      data-testid="brand-primary-logo"
      style={{ maxWidth: `${maxWidth}px`, width: "100%", height: "auto", display: "block", ...style }}
      className={className}
      draggable={false}
    />
  );
}

/**
 * Icon-only mark. Used for mobile header, favicon, and small placements.
 */
export function AppIcon({ size = 48, className = "", style = {} }) {
  return (
    <img
      src={BRAND.appIcon}
      alt={BRAND.alt}
      data-testid="brand-app-icon"
      style={{ width: `${size}px`, height: `${size}px`, display: "block", ...style }}
      className={className}
      draggable={false}
    />
  );
}
